import PropTypes from 'prop-types'

const CategoryHeader = ({ title }) => {
    return (
        <header className='header'>
            <h1>{title}</h1>
        </header>
    )
}

CategoryHeader.defaultProps = {
    title: 'Info Hub Folder',
}

CategoryHeader.propTypes = {
    title: PropTypes.string.isRequired,
}

export default CategoryHeader
